import {
  Button,
  Divider,
  Form,
  Input,
  Select,
  SelectProps,
  Spin,
  message,
} from "antd";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import { useMutation, useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PhoneInputWithCountrySelect, {
  parsePhoneNumber,
} from "react-phone-number-input";
import EditSvg from "../../../../assets/settings/Edit.svg";
import mailSvg from "../../../../assets/settings/Message.svg";
import phoneSvg from "../../../../assets/settings/Phone.svg";
import { getLocation } from "../../../../network/location";
import { listServicesCategories } from "../../../../network/service";
import { updateLocation } from "../../../../network/settings";
import queryClient from "../../../../services/react-query/queryClient";
import { queryKeys } from "../../../../services/react-query/queryKeys";
import AddressLocation from "./AddresLocation";
import EditWorkingsHours from "./items/EditWorkingsHours";
const UpdateBranch = ({ id = 0, cancel }: any) => {
  const [isEdit, setIsEdit] = useState(false);
  const { locale } = useIntl();
  const intl = useIntl();
  const [secPhone, setSecPhone] = useState(false);
  const { data: services } = useQuery([queryKeys?.listServicesOnboarind], () =>
    listServicesCategories({ is_parent: 1 })
  );

  const {
    data: Location,
    isError,
    isLoading,
  } = useQuery([queryKeys.Locations, id], () => getLocation(id, true));
  const {
    id: SalonId,
    business_location,
    email,
    name,
    phone,
    contact_number,
    opening_hours,
    billing_information,
    primary_service_categories,
    secondary_service_categories,
    lat,
    lng,
  }: any = Location?.data || {};

  console.log(Location?.data?.lat, Location?.data?.lng);

  const [newLatLng, setNewLatLng] = useState<any>();
  const [newLatLng2, setNewLatLng2] = useState<any>();
  const [mapInfo, setMapInfo] = useState(business_location?.Address || "");
  const [mapInfo2, setMapInfo2] = useState(billing_information?.Address || "");
  useEffect(() => {
    if (Location?.data) {
      setNewLatLng({
        lat: Location?.data?.lat,
        lng: Location.data.lng,
      });
      setMapInfo(Location?.data?.business_location?.Address);
      setMapInfo2(Location?.data?.billing_information?.Address);
      setNewLatLng2({
        lat: Location?.data?.billing_information?.lat,
        lng: Location?.data?.billing_information?.lng,
      });
    }
  }, [Location?.data]);
  const options1: SelectProps["options"] = primary_service_categories?.map(
    (e: any) => {
      return {
        label: e?.name[locale],
        value: e?.id,
      };
    }
  );
  const options2: SelectProps["options"] = secondary_service_categories?.map(
    (e: any) => {
      return {
        label: e?.name[locale],
        value: e?.id,
      };
    }
  );

  const [mainOptions, setMainOptions] = useState<any>(options1);
  const [secondaryOptions, setSecondaryOptions] = useState<any>(options2);
  const handleMainBusinessTypeChange = (selectedValue: any) => {
    // This assumes `selectedValue` is the newly selected value in the main select
    const newSecondaryOptions = services?.data
      ?.filter((service: any) => service?.id !== selectedValue)
      .map((service: any) => ({
        label: service?.name,
        value: service?.id,
      }));

    setSecondaryOptions(newSecondaryOptions);
  };

  // Function to handle change in secondary business type select
  const handleSecondaryBusinessTypeChange = (selectedValues: any[]) => {
    // This assumes `selectedValues` is the array of newly selected values in the secondary select
    const newMainOptions = services?.data
      .filter((service: any) => !selectedValues.includes(service.id))
      .map((service: any) => ({
        label: service.name,
        value: service.id,
      }));

    setMainOptions(newMainOptions);
  };
  const {
    mutate: UpdateLocation,
    isLoading: isSubmitting,
    error: addSalonError,
  } = useMutation(updateLocation, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404
      ) {
        message.error(res?.response?.data?.message);
      } else {
        message.success("Location updated successfully");
        queryClient.invalidateQueries([queryKeys.Locations]);
        setIsEdit((e: any) => (e = false));
      }
    },
  });

  let ids1 = primary_service_categories?.map(function (category: any) {
    return category?.id;
  });
  let ids2 = secondary_service_categories?.map(function (category: any) {
    return category?.id;
  });
  useEffect(() => {
    if (services?.data) {
      const serviceOptions = services.data.map((service: any) => ({
        label: service?.name,
        value: service?.id,
      }));

      // Assuming you have ways to get current selections for main and secondary services.
      // For initial load, these could be empty or derived from `Location` data.
      const currentMainSelection = primary_service_categories?.[0]?.id; // Assuming single select for main
      const currentSecondarySelections = secondary_service_categories?.map(
        (c: any) => c.id
      ); // Assuming multi-select for secondary

      const filteredMainOptions = serviceOptions?.filter(
        (option: any) => !currentSecondarySelections?.includes(option?.value)
      );
      const filteredSecondaryOptions = serviceOptions?.filter(
        (option: any) => option?.value !== currentMainSelection
      );

      setMainOptions(filteredMainOptions);
      setSecondaryOptions(filteredSecondaryOptions);
    }
  }, [
    services?.data,
    primary_service_categories,
    secondary_service_categories,
  ]);
  const [form] = Form.useForm();
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Stop the form from submitting
    }
  };
  const onFinish = (value: {
    primary_service_categories: any;
    business_location: any;
    invoice_note: any;
    opening_hours: any;
    phone: any;
    billing_information: any;
  }) => {
    const opening_hoursData = Object?.entries(value?.opening_hours)?.map(
      ([day, { opening_time, closing_time }]: [string, any]) => {
        const formattedOpeningTime = dayjs(opening_time).format("HH:mm");
        const formattedClosingTime = dayjs(closing_time).format("HH:mm");

        return {
          day: day,
          opening_time: formattedOpeningTime,
          closing_time: formattedClosingTime,
        };
      }
    );

    const phoneNumber = parsePhoneNumber(value?.phone || "");
    // console.log(value, "valuevaluevaluevaluevaluevaluevaluevaluevalue");

    UpdateLocation({
      ...value,
      // lat: markerPosition?.lat,
      // lng: markerPosition?.lng,
      lat: newLatLng?.lat,
      lng: newLatLng?.lng,
      business_location: {
        ...value?.business_location,
        Address: mapInfo,
        lat: newLatLng?.lat,
        lng: newLatLng?.lng,
      },
      billing_information: {
        ...value?.billing_information,
        lat: newLatLng2?.lat,
        lng: newLatLng2?.lng,
        Address: mapInfo2,
      },
      id: SalonId,
      invoice_note: "",
      contact_country_code: phoneNumber ? phoneNumber?.country : "", // Extracting the phone number from parsedPhoneNumber
      contact_number: phoneNumber ? phoneNumber?.nationalNumber : "",
      opening_hours: opening_hoursData,
      primary_service_categories: Array.isArray(
        value?.primary_service_categories
      )
        ? value?.primary_service_categories
        : [value?.primary_service_categories],
    });
  };
  if (isLoading) {
    return <Spin className="flex items-center justify-center w-full" />;
  }

  if (isError) {
    return <div>Error fetching data</div>;
  }
  const openingAndClosingTimes: any = {};
  opening_hours?.forEach((data: any) => {
    const hour1 = parseInt(data?.opening_time?.split(":")[0], 10);
    const hour2 = parseInt(data?.closing_time?.split(":")[0], 10);
    const min1 = parseInt(data?.opening_time?.split(":")[1], 10);
    const min2 = parseInt(data?.closing_time?.split(":")[1], 10);
    console.log(data, "min1");
    console.log(min1, min2, "min1min1min1");

    openingAndClosingTimes[data?.day] = {
      opening_time: dayjs().hour(hour1).minute(min1),
      closing_time: dayjs().hour(hour2).minute(min2),
    };
  });

  return (
    <div className="bg-[#EEF0FF] md:px-6 md:py-8">
      <div
        className="flex items-center gap-2 mb-6 cursor-pointer"
        onClick={() => cancel()}
      >
        {locale === "ar" ? (
          <IoIosArrowForward className="text-[#9999A7] flex items-center my-auto" />
        ) : (
          <IoIosArrowBack className="text-[#9999A7] flex items-center my-auto" />
        )}
        <h5 className="text-base font-semibold">
          {name[locale]} - {business_location?.City}
        </h5>
      </div>

      <Divider />
      <div
        onClick={() => setIsEdit((e: any) => !e)}
        className="flex items-center justify-end gap-1 cursor-pointer mb-4 text-sm text-[#75757E]"
      >
        <img src={EditSvg} alt="" />
        <span className="text-color-primary">
          {intl.formatMessage({ id: "edit" })}
        </span>
      </div>
      <div onKeyDown={handleKeyDown}>
        <Form
          name="EditSalonBranch"
          form={form}
          className="lg:grid lg:grid-cols-2 max-md:grid-cols-1 lg:gap-4"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            name: {
              ar: name?.ar || "",
              en: name?.en || "",
            },
            email: email || "",
            phone: contact_number || phone || "",
            business_location: {
              Building: business_location?.Building || "",
              streetName: business_location?.streetName || "",
              District: business_location?.District || "",
              City: business_location?.City || "",
              Country: business_location?.Country || "",
              main: business_location?.main || "",
            },
            billing_information: {
              Building: billing_information?.Building || "",
              streetName: billing_information?.streetName || "",
              District: billing_information?.District || "",
              City: billing_information?.City || "",
              Country: billing_information?.Country || "",
              main: billing_information?.main || "",
              lat: billing_information?.lat || "",
              lng: billing_information?.lng || "",
            },
            primary_service_categories: ids1,
            secondary_service_categories: ids2,
            opening_hours: openingAndClosingTimes,
          }}
        >
          <div
            className={`${!isEdit || "p-4"} bg-white rounded-lg max-xl:mb-2`}
            style={{ background: !isEdit ? "#EEF0FF" : "#FFFFFF" }}
          >
            <div className="mb-4 text-base">
              <FormattedMessage id="contactInformation" />
            </div>
            {!isEdit ? (
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2 px-6 py-3 text-center bg-white rounded-lg">
                  <img src={phoneSvg} alt="" />
                  <span className="text-sm font-semibold" dir="ltr">
                    {contact_number}
                  </span>
                </div>
                <div className="flex items-center gap-2 px-6 py-3 text-center bg-white rounded-lg">
                  <img src={mailSvg} alt="" />
                  <span className="text-sm font-semibold">{email}</span>
                </div>
              </div>
            ) : (
              <div className="w-full">
                <div className="max-md:w-full">
                  <div className="flex items-center gap-4 max-lg:flex-col">
                    <Form.Item
                      name={["name", "ar"]} // Change "email" to "name"
                      label={
                        <div className="text-sm">
                          {intl.formatMessage({ id: "branchNameLabelArabic" })}
                        </div>
                      }
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "branchNameRequiredErrorMessage",
                          }),
                        },
                        {
                          validator: (_, value) => {
                            if (!/^[ء-ي0-9 ]+$/.test(value)) {
                              // Regular expression for Arabic characters and numbers
                              return Promise.reject(
                                new Error(
                                  intl.formatMessage({
                                    id: `localization.Only[ar]`, // Adjust the localization key as necessary
                                  })
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      className="w-full"
                      required={false}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name={["name", "en"]} // Change "email" to "name"
                      label={
                        <div className="text-sm">
                          {intl.formatMessage({ id: "branchNameLabelEnglish" })}
                        </div>
                      }
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "branchNameRequiredErrorMessage",
                          }),
                        },
                        {
                          validator: (_, value) => {
                            if (!/^[A-Za-z0-9 ]+$/.test(value)) {
                              // Regular expression for English characters and numbers
                              return Promise.reject(
                                new Error(
                                  intl.formatMessage({
                                    id: `localization.Only[en]`, // Adjust the localization key as necessary
                                  })
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                      className="w-full"
                      required={false}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="flex items-center w-full gap-2 max-md:flex-col">
                    <Form.Item
                      label={
                        <div className="text-sm">
                          {intl.formatMessage({ id: "mainPhoneNumberLabel" })}
                        </div>
                      }
                      name="phone"
                      required={false}
                      className="w-full"
                    >
                      <PhoneInputWithCountrySelect
                        defaultCountry="SA"
                        // value={value1}
                        // onChange={setValue1}
                        onChange={() => {}}
                        international
                        limitMaxLength={true}
                        className="!border-[1px] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
                      />
                    </Form.Item>
                    <Button
                      type="default"
                      className={`flex items-center justify-center gap-2 md:mt-1 w-full ${
                        secPhone && "hidden"
                      }`}
                      onClick={() => setSecPhone((e: any) => !e)}
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.4141 2.3999H4.78906C4.20911 2.4006 3.65312 2.63129 3.24303 3.04137C2.83295 3.45146 2.60226 4.00745 2.60156 4.5874L2.60156 14.2124C2.60226 14.7923 2.83295 15.3483 3.24303 15.7584C3.65312 16.1685 4.20911 16.3992 4.78906 16.3999H14.4141C14.994 16.3992 15.55 16.1685 15.9601 15.7584C16.3702 15.3483 16.6009 14.7923 16.6016 14.2124V4.5874C16.6009 4.00745 16.3702 3.45146 15.9601 3.04137C15.55 2.63129 14.994 2.4006 14.4141 2.3999ZM15.7266 14.2124C15.7266 14.5605 15.5883 14.8943 15.3421 15.1405C15.096 15.3866 14.7622 15.5249 14.4141 15.5249H4.78906C4.44097 15.5249 4.10713 15.3866 3.86098 15.1405C3.61484 14.8943 3.47656 14.5605 3.47656 14.2124V4.5874C3.47656 4.23931 3.61484 3.90547 3.86098 3.65932C4.10713 3.41318 4.44097 3.2749 4.78906 3.2749H14.4141C14.7622 3.2749 15.096 3.41318 15.3421 3.65932C15.5883 3.90547 15.7266 4.23931 15.7266 4.5874V14.2124Z"
                          fill="#00086D"
                        />
                        <path
                          d="M9.89766 6.63037H9.29766V9.33037H6.59766V9.93037H9.29766V12.6304H9.89766V9.93037H12.5977V9.33037H9.89766V6.63037Z"
                          fill="#00086D"
                        />
                      </svg>
                      {intl.formatMessage({ id: "extraNumberButton" })}
                    </Button>
                  </div>
                  {secPhone && (
                    <Form.Item
                      name="additional_contact_number"
                      required={false}
                      className=""
                    >
                      <PhoneInputWithCountrySelect
                        defaultCountry="SA"
                        onChange={() => {}}
                        international
                        limitMaxLength={true}
                        className="!border-[1px] w-[99%] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
                      />
                    </Form.Item>
                  )}
                </div>
                <Form.Item
                  name={"email"}
                  label={
                    <div className="text-sm">
                      {intl.formatMessage({ id: "branchEmailAddressLabel" })}
                    </div>
                  }
                  rules={[{ type: "email" }]}
                >
                  <Input />
                </Form.Item>
              </div>
            )}
          </div>
          <div
            className={`${!isEdit || "p-4"} bg-white rounded-lg max-xl:mb-2`}
            style={{ background: !isEdit ? "#EEF0FF" : "#FFFFFF" }}
          >
            <div className="mb-4 text-base">
              <FormattedMessage id="typeOfWork" />
            </div>

            {!isEdit ? (
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2 px-6 py-3 text-center bg-white rounded-lg">
                  <span className="font-semibold text-sm text-[#75757E] capitalize">
                    {intl.formatMessage({ id: "basicServicesLabel" })}
                  </span>
                  <span className="text-sm font-semibold capitalize">
                    {primary_service_categories[0]?.name[locale]}
                  </span>
                </div>
                <div className="flex items-center gap-2 px-6 py-3 text-center bg-white rounded-lg">
                  <span className="font-semibold text-sm text-[#75757E] capitalize">
                    {intl.formatMessage({ id: "secondaryServicesLabel" })}
                  </span>
                  <span className="text-sm font-semibold capitalize">
                    {secondary_service_categories
                      .map((e: any) => e.name[locale])
                      .join(" - ")}
                  </span>
                </div>
              </div>
            ) : (
              <div className="w-full">
                <Form.Item
                  name={"primary_service_categories"}
                  label={
                    <div className="text-sm">
                      {intl.formatMessage({ id: "mainServiceLabel" })}
                    </div>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "mainServiceRequired",
                      }),
                    },
                  ]}
                  className="w-full"
                >
                  <Select
                    onChange={handleMainBusinessTypeChange}
                    options={mainOptions}
                    defaultValue={ids1}
                    className="w-full"
                  />
                </Form.Item>
                <Form.Item
                  name={"secondary_service_categories"}
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "secondaryServiceRequired",
                      }),
                    },
                  ]}
                  label={
                    <div className="text-sm">
                      {intl.formatMessage({ id: "secondaryServiceLabel" })}
                    </div>
                  }
                >
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    defaultValue={ids2}
                    onChange={handleSecondaryBusinessTypeChange}
                    options={secondaryOptions}
                    maxLength={1}
                    // optionRender={(option: any) => <div>{option.data.label}</div>}
                  />
                </Form.Item>
              </div>
            )}
          </div>
          <AddressLocation
            form={form}
            setMapInfo={setMapInfo}
            mapInfo={mapInfo}
            setNewLatLng={setNewLatLng}
            newLatLng={newLatLng}
            isEdit={isEdit}
            label={intl.formatMessage({ id: "business_location_label" })}
            name="business_location"
            business_location={business_location}
          />
          <AddressLocation
            form={form}
            setMapInfo={setMapInfo2}
            mapInfo={mapInfo2}
            setNewLatLng={setNewLatLng2}
            newLatLng={newLatLng2}
            isEdit={isEdit}
            label={intl.formatMessage({ id: "billing_information_label" })}
            name="billing_information"
            business_location={billing_information}
          />
          <EditWorkingsHours
            isEdit={isEdit}
            opening_hours={opening_hours}
            form={form}
          />
          {isEdit && (
            <div className="flex items-center justify-end gap-4 md:col-span-2">
              <Button
                type="primary"
                htmlType="submit"
                className="min-w-[10rem] max-w-[10rem]"
                loading={isSubmitting}
              >
                {intl.formatMessage({ id: "saveChangesButton" })}
              </Button>
              <Button
                onClick={() => setIsEdit((e: any) => !e)}
                type="primary"
                className="min-w-[10rem] max-w-[10rem] btn-primary-not"
              >
                {intl.formatMessage({ id: "cancelButton" })}
              </Button>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

export default UpdateBranch;
